import { handleActions } from "redux-actions";

import {
	getAssetsListAsyncAction,
	postAssetAsyncAction,
	updateAssetAsyncAction,
	resetAction,
} from "./assetsActions";

const defaultAjaxState = {
	response: null,
	error: null,
	loading: false,
};

const initialState = {
	list: defaultAjaxState,
	post_asset: defaultAjaxState,
	update_asset: defaultAjaxState,
};

export const assetsReducer = handleActions(
	new Map([
		// get asset list
		[
			getAssetsListAsyncAction.request,
			(state, { payload }) => ({
				...state,
				list: {
					...initialState.list,
					loading: true,
				},
			}),
		],
		[
			getAssetsListAsyncAction.success,
			(state, { payload }) => ({
				...state,
				list: {
					...initialState.list,
					response: payload,
				},
			}),
		],
		[
			getAssetsListAsyncAction.failure,
			(state, { payload }) => ({
				...state,
				list: {
					...initialState.list,
					error: payload,
				},
			}),
		],

		// post asset create
		[
			postAssetAsyncAction.request,
			(state, { payload }) => ({
				...state,
				post_asset: {
					...initialState.post_asset,
					loading: true,
				},
			}),
		],
		[
			postAssetAsyncAction.success,
			(state, { payload }) => ({
				...state,
				post_asset: {
					...initialState.post_asset,
					response: payload,
				},
			}),
		],
		[
			postAssetAsyncAction.failure,
			(state, { payload }) => ({
				...state,
				post_asset: {
					...initialState.post_asset,
					error: payload,
				},
			}),
		],

		// put asset update
		[
			updateAssetAsyncAction.request,
			(state, { payload }) => ({
				...state,
				update_asset: {
					...initialState.update_asset,
					loading: true,
				},
			}),
		],
		[
			updateAssetAsyncAction.success,
			(state, { payload }) => ({
				...state,
				update_asset: {
					...initialState.update_asset,
					response: payload,
				},
			}),
		],
		[
			updateAssetAsyncAction.failure,
			(state, { payload }) => ({
				...state,
				update_asset: {
					...initialState.update_asset,
					error: payload,
				},
			}),
		],

		// reset
		[
			resetAction,
			(state, { payload }) => ({
				...state,
				[payload]: initialState[payload],
			}),
		],
	]),
	initialState
);
